<template>
    <div class='content'>
        <div class="con-title">
            <div :class="$i18n.locale + '_con-1'">{{ $t('content163') }} </div>
            <div class="con-2">
                {{ $t('content164') }}
            </div>
            <!-- <div class="btn-box">
                <div class="btn-blue">预约演示</div>
                <div class="btn-we">参观一下</div>
            </div> -->
            <img :src="$i18n.locale == 'zh' ? require('@/assets/youxi_banner@2x.png'):require('@/assets/en_youxi_banner@2x.png')" class="con-img" alt="">
        </div>

        <div class="over">
            <div class="over-text">
                {{ $t('content165') }}
            </div>

            <div class="over-box">
                <img src="@/assets/fukuan_icon@2x.png" class="over-img" alt="">
                <div class="over-text-1">{{ $t('content166') }}</div>
                <div class="over-text-2">{{ $t('content167') }}</div>
                <img src="@/assets/fukuanfnagshi_img@2x.png" class="img-poa" alt="">
            </div>
            <div class="over-box1">
                <div class="flex-box11">
                    <img src="@/assets/jiesuan_icon@2x.png" class="over-img" alt="">
                    <div class="over-text-1">{{ $t('content168') }}</div>
                    <div class="over-text-3 ">
                        {{ $t('content169') }}</div>
                    <img src="@/assets/benbijiesuan_img@2x.png" class="over-img1" alt="">
                </div>
                <div class="flex-box1">
                    <img src="@/assets/daozhang_icon@2x (1).png" class="over-img" alt="">
                    <div class="over-text-1">{{ $t('content170') }}</div>
                    <div class="over-text-3 ">
                        {{ $t('content171') }}</div>
                    <img src="@/assets/daozhang_img@2x.png" class="over-img1" alt="">

                </div>
            </div>
        </div>

        <div :class="$i18n.locale + '_over-text'">
            {{ $t('content172') }}
        </div>
        <div :class="$i18n.locale + '_box-bottom'">
            <div class="top-box">
                <div class="box-bottom-1">
                    <img src="@/assets/jianrong_icon@2x.png" class="img-icon" alt="">
                    <div class="bottom-box-title">{{ $t('content173') }}</div>
                    <div class="bottom-box-title1">{{ $t('content174') }}</div>
                </div>
                <div class="box-bottom-1">
                    <img src="@/assets/xuqiu_icon@2x.png" class="img-icon" alt="">
                    <div class="bottom-box-title">{{ $t('content175') }}</div>
                    <div class="bottom-box-title1">{{ $t('content176') }}</div>

                </div>
                <div class="box-bottom-1">
                    <img src="@/assets/jine_icon@2x.png" class="img-icon" alt="">
                    <div class="bottom-box-title">{{ $t('content177') }}</div>
                    <div class="bottom-box-title1">{{ $t('content178') }}</div>

                </div>
            </div>
            <div :class="$i18n.locale + '_bottom-box'">
                <div class="box-bottom-1">
                    <img src="@/assets/chenggonglv_icon@2x.png" class="img-icon" alt="">
                    <div class="bottom-box-title">{{ $t('content179') }}</div>
                    <div class="bottom-box-title1">{{ $t('content180') }}</div>

                </div>
                <div class="box-bottom-1">
                    <img src="@/assets/zhifu_icon@2x.png" class="img-icon" alt="">
                    <div class="bottom-box-title">{{ $t('content181') }}</div>
                    <div class="bottom-box-title1">{{ $t('content182') }}</div>

                </div>
                <div class="box-bottom-1">
                    <img src="@/assets/anquan_icon@2x.png" class="img-icon" alt="">
                    <div class="bottom-box-title">{{ $t('content25') }}</div>
                    <div class="bottom-box-title1">{{ $t('content183') }}</div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'index_4',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
}
</script>
<style scoped>
.con-title {
    position: relative;
}

.zh_con-1 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 237px;
    left: 360px;
}

.en_con-1 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 180px;
    left: 260px;
    width: 700px;
    text-align: center;
}

.con-2 {
    width: 484px;
    font-size: 22px;
    color: #666666;
    position: absolute;
    left: 360px;
    top: 306px;
    line-height: 32px;
}

.con-img {
    width: 100%;
    height: 750px;
}

.content {
    padding-bottom: 154px;
}

.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 450px;
    left: 360px;
}

.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    cursor: pointer;
    color: #fff;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
}

.over-img {
    width: 54px;
    height: 54px;
}

.btn-we {
    width: 132px;
    cursor: pointer;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #4873FF;
    margin-left: 12px;

}

.over {
    padding: 143px 360px;
    /* height: 300px; */
}

.over-text {
    color: #333333;
    font-size: 36px;
    width: 1108px;
    margin: 0 auto;
}
.zh_over-text {
    color: #333333;
    font-size: 36px;
    width: 1108px;
    margin: 0 auto;
}
.en_over-text {
    color: #333333;
    font-size: 36px;
    width: 1108px;
    margin: 0 auto;
    margin-top:50px;
}

.over-box {
    /* width: 1200px; */
    height: 250px;
    margin-top: 73px;
    background-color: #F8F9FF;
    padding: 47px;
    position: relative;
    border-radius: 24px;
    margin-bottom: 40px;
}

.over-text-1 {
    color: #333333;
    font-size: 24px;
    margin-top: 23px;
    line-height: 58px;
}

.over-text-2 {
    color: #666666;
    font-size: 20px;
    line-height: 32px;
    width: 509px;
}

.over-text-3 {
    color: #666666;
    font-size: 20px;
    line-height: 32px;
    width: 469px;
}

.img-poa {
    width: 456px;
    height: 364px;
    position: absolute;
    right: 62px;
    top: -70px;
}

.over-box1 {
    display: flex;
    justify-content: space-between;
    /* padding: 0 360px; */
    height: 517px;

}

.over-img1 {
    width: 480px;
    height: 230px;
    margin-top: 50px;
}

.flex-box11 {
    width: 560px;
    height: 517px;
    background-color: #F8F9FF;
    border-radius: 24px;
    padding: 47px 0 0 47px;
    margin-right: 40px
}

.flex-box1 {
    width: 560px;
    height: 517px;
    background-color: #F8F9FF;
    border-radius: 24px;
    padding: 47px 0 0 47px;
    margin-right: 40px
}

.en_box-bottom {
    width: 1200px;
    height: 1000px;
    margin: 0 auto;
    margin-top: 69px;
}

.zh_box-bottom {
    width: 1200px;
    height: 750px;
    margin: 0 auto;
    margin-top: 69px;
}

.top-box {
    display: flex;
    justify-content: space-between;
}

.zh_bottom-box {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.en_bottom-box {
    display: flex;
    justify-content: space-between;
    margin-top: 100px;
}

.box-bottom-1 {
    width: 371px;
    height: 300px;
    border-radius: 50px 2px;
    background-color: #F8F9FF;
    padding: 38px 42px;
    margin-right: 44px;
}

.img-icon {
    width: 70px;
    height: 70px;
}

.bottom-box-title {
    font-size: 28px;
    color: #333333;
    line-height: 40px;
    margin: 30px 0 16px 0;
}

.bottom-box-title1 {
    font-size: 22px;
    line-height: 32px;
    color: #666666;
    width: 313px;
}
</style>